var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "#285FCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15079 9.24074C4.73147 8.88132 4.10017 8.92988 3.74074 9.34921C3.38132 9.76853 3.42988 10.3998 3.84921 10.7593L5.15079 9.24074ZM14.7348 7.17828C15.1094 6.77246 15.0841 6.1398 14.6783 5.7652C14.2725 5.39059 13.6398 5.4159 13.2652 5.82172L14.7348 7.17828ZM8 13L7.34921 13.7593C7.75767 14.1094 8.36991 14.0736 8.7348 13.6783L8 13ZM3.84921 10.7593L7.34921 13.7593L8.65079 12.2407L5.15079 9.24074L3.84921 10.7593ZM8.7348 13.6783L14.7348 7.17828L13.2652 5.82172L7.2652 12.3217L8.7348 13.6783Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconFilled);
export default __webpack_public_path__ + "static/media/checkIconFilled.a330cfbe.svg";
export { ForwardRef as ReactComponent };